(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/coupons/coupon-1x2.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/coupons/coupon-1x2.js');
"use strict";


const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
const _svs$ui$reactTable = svs.ui.reactTable,
  Table = _svs$ui$reactTable.Table,
  TableHead = _svs$ui$reactTable.TableHead,
  TableRow = _svs$ui$reactTable.TableRow,
  TableHeader = _svs$ui$reactTable.TableHeader,
  TableBody = _svs$ui$reactTable.TableBody,
  TableCell = _svs$ui$reactTable.TableCell;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
const signIndexToTitle = svs.components.sport.tipsenShared.signIndexToTitle;
const getAriaLabel = (eventItem, eventIndex, signs, isMobile) => {
  const awayTeamShort = eventItem.awayTeamShort,
    awayTeamLong = eventItem.awayTeamLong,
    homeTeamShort = eventItem.homeTeamShort,
    homeTeamLong = eventItem.homeTeamLong,
    infoLine = eventItem.infoLine;
  let ariaLabel = "Match ".concat(eventIndex + 1, ", ").concat(isMobile ? "".concat(homeTeamShort, " mot ").concat(awayTeamShort) : "".concat(homeTeamLong, " mot ").concat(awayTeamLong), ".");
  if (infoLine) {
    ariaLabel += "".concat(infoLine, ".");
  }
  const signsAsText = [];
  if (signs[0]) {
    signsAsText.push('Etta');
  }
  if (signs[1]) {
    signsAsText.push('Kryss');
  }
  if (signs[2]) {
    signsAsText.push('Tvåa');
  }
  if (signsAsText) {
    ariaLabel += " ".concat(signsAsText.join(', '));
  }
  return ariaLabel;
};

const useMemoizedMinHeight = _ref => {
  let ref = _ref.ref,
    hasData = _ref.hasData;
  useEffect(() => {
    if (ref.current) {
      if (hasData) {
        ref.current.removeAttribute('style');
      }
      const height = ref.current.getBoundingClientRect().height;
      ref.current.setAttribute('style', "min-height: ".concat(height, "px;"));
    }
  });
};

const Coupon1x2 = _ref2 => {
  let branding = _ref2.branding,
    drawData = _ref2.drawData,
    isPixMix = _ref2.isPixMix;
  const _ref3 = drawData || {},
    productId = _ref3.productId,
    events = _ref3.events;
  const isMobile = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  return React.createElement("div", {
    className: "coupon-1x2-outcomes"
  }, React.createElement(Table, {
    "aria-label": "Tabell med kupongens matcher och valda tecken",
    inverted: true,
    role: "table"
  }, React.createElement(TableHead, null, React.createElement(TableRow, {
    className: "u-flex u-flex-justify-content-between u-border-bottom-1 border-opacity-white-60"
  }, React.createElement(TableHeader, {
    className: "coupon-1x2-outcome-header"
  }, React.createElement("p", {
    className: "margin-bottom-0 f-medium fc-opacity-white-80"
  }, "Match")), React.createElement(TableHeader, {
    className: "coupon-1x2-outcome-header"
  }, React.createElement("p", {
    className: "margin-bottom-0 f-medium fc-opacity-white-80",
    "data-testid": "table-of-events-goal-type"
  }, "Tippa resultat")))), React.createElement(TableBody, null, events.map((eventItem, eventIndex) => {
    const key = "".concat(eventItem.captionShort, "_").concat(eventIndex);
    return React.createElement(TableRow, {
      "aria-labelledby": key,
      key: key
    }, React.createElement(TableCell, {
      className: "coupon-1x2-outcome-td"
    }, React.createElement(MatchRow, {
      branding: branding,
      eventIndex: eventIndex,
      eventItem: eventItem,
      isMobile: isMobile,
      isPixMix: isPixMix,
      productId: productId,
      rowKey: key
    })));
  }))));
};

const MatchRow = _ref4 => {
  let eventItem = _ref4.eventItem,
    eventIndex = _ref4.eventIndex,
    productId = _ref4.productId,
    isMobile = _ref4.isMobile,
    isPixMix = _ref4.isPixMix,
    rowKey = _ref4.rowKey;
  const ref = useRef();
  const pixHandler = svs.components.sport.pixHandler.getPixHandler({
    isPixMix
  }); 
  const pixData = pixHandler.getModel(productId);
  const signs = (pixData === null || pixData === void 0 ? void 0 : pixData[eventIndex]) || [];
  const captionShort = eventItem.captionShort,
    captionLong = eventItem.captionLong,
    infoLine = eventItem.infoLine,
    outcomesAsList = eventItem.outcomesAsList;
  useMemoizedMinHeight({
    ref,
    hasData: Boolean(pixData)
  });
  const ariaLabel = getAriaLabel(eventItem, eventIndex, signs, isMobile);
  return React.createElement("div", {
    className: "u-border-bottom-1 border-opacity-white-60 notranslate padding-top padding-bottom u-flex-align-items-center",
    key: "".concat(captionShort, "-").concat(eventIndex),
    ref: ref
  }, React.createElement("p", {
    "aria-label": ariaLabel,
    className: "u-flex u-flex-justify-content-between width-100 margin-bottom-0",
    id: rowKey
  }, React.createElement("span", {
    "data-testid": "event-".concat(eventIndex, "-description")
  }, "".concat(eventIndex + 1, ". ").concat(isMobile ? captionShort : captionLong), Boolean(infoLine) && React.createElement("div", {
    className: "padding-left-1 fc-grey-400"
  }, infoLine)), React.createElement("span", {
    className: "u-flex f-100 fc-white quickplay-modal-outcomes",
    "data-testid": "event-".concat(eventIndex, "-outcomes")
  }, React.createElement(EventOutcomes, {
    outcomesAsList: outcomesAsList,
    signs: signs
  }))));
};

const EventOutcomes = _ref5 => {
  let signs = _ref5.signs,
    outcomesAsList = _ref5.outcomesAsList;
  const labels = outcomesAsList || signIndexToTitle[EventTypeId.EVENT_1X2];
  return React.createElement(React.Fragment, null, signs.map((isSelected, signIndex) => {
    const key = "".concat(signIndex, "_").concat(labels[signIndex]);
    return React.createElement("span", {
      className: isSelected ? 'margin-half coupon-sign coupon-sign-selected' : 'margin-half coupon-sign',
      key: key
    }, labels[signIndex]);
  }));
};
setGlobal('svs.components.sport.quickplayModal.coupons.Coupon1x2', Coupon1x2);

 })(window);